import { c as _c } from "react/compiler-runtime";
import { useDropLinkPreviewToggleControl } from "@/components/waves/drops/useDropLinkPreviewToggleControl";
import DropPartMarkdownWithPropLogger from "@/components/drops/view/part/DropPartMarkdownWithPropLogger";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import type { ApiDropMentionedUser } from "@/generated/models/ApiDropMentionedUser";
import type { ApiDropGroupMention } from "@/generated/models/ApiDropGroupMention";
import type { ApiDropPart } from "@/generated/models/ApiDropPart";
import type { ApiDropReferencedNFT } from "@/generated/models/ApiDropReferencedNFT";
import type { ApiMentionedWave } from "@/generated/models/ApiMentionedWave";
import type { ApiWaveMin } from "@/generated/models/ApiWaveMin";
import React from "react";
import EditDropLexical from "./EditDropLexical";
import WaveDropQuoteWithDropId from "./WaveDropQuoteWithDropId";
interface WaveDropPartContentMarkdownProps {
  readonly mentionedUsers: Array<ApiDropMentionedUser>;
  readonly mentionedGroups?: Array<ApiDropGroupMention> | undefined;
  readonly mentionedWaves: Array<ApiMentionedWave>;
  readonly referencedNfts: Array<ApiDropReferencedNFT>;
  readonly part: ApiDropPart;
  readonly wave: ApiWaveMin;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly isEditing?: boolean | undefined;
  readonly isSaving?: boolean | undefined;
  readonly onSave?: ((newContent: string, mentions?: ApiDropMentionedUser[], mentionedGroups?: ApiDropGroupMention[], mentionedWaves?: ApiMentionedWave[]) => void) | undefined;
  readonly onCancel?: (() => void) | undefined;
  readonly drop?: ApiDrop | undefined; // Add drop to check for edited status
  readonly onLinkCardActionsActiveChange?: ((href: string, active: boolean) => void) | undefined;
}
const WaveDropPartContentMarkdown: React.FC<WaveDropPartContentMarkdownProps> = t0 => {
  const $ = _c(47);
  const {
    mentionedUsers,
    mentionedGroups: t1,
    mentionedWaves,
    referencedNfts,
    part,
    wave,
    onQuoteClick,
    isEditing: t2,
    isSaving: t3,
    onSave,
    onCancel,
    drop,
    onLinkCardActionsActiveChange
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const mentionedGroups = t4;
  const isEditing = t2 === undefined ? false : t2;
  const isSaving = t3 === undefined ? false : t3;
  const linkPreviewToggleControl = useDropLinkPreviewToggleControl(drop);
  let t5;
  if ($[2] !== drop || $[3] !== wave) {
    t5 = drop?.serial_no === undefined ? [] : [`${wave.id}:${drop.serial_no}`];
    $[2] = drop;
    $[3] = wave;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const currentQuotePath = t5;
  if (isEditing) {
    const t6 = part.content ?? "";
    const t7 = drop?.wave.authenticated_user_admin === true;
    let t8;
    if ($[5] !== onSave) {
      t8 = (content, mentions, groups, waves) => {
        if (onSave) {
          onSave(content, mentions, groups, waves);
        }
      };
      $[5] = onSave;
      $[6] = t8;
    } else {
      t8 = $[6];
    }
    let t9;
    if ($[7] !== onCancel) {
      t9 = () => {
        if (onCancel) {
          onCancel();
        }
      };
      $[7] = onCancel;
      $[8] = t9;
    } else {
      t9 = $[8];
    }
    let t10;
    if ($[9] !== isSaving || $[10] !== mentionedGroups || $[11] !== mentionedUsers || $[12] !== mentionedWaves || $[13] !== t6 || $[14] !== t7 || $[15] !== t8 || $[16] !== t9 || $[17] !== wave.id) {
      t10 = <EditDropLexical initialContent={t6} initialMentions={mentionedUsers} initialGroupMentions={mentionedGroups} initialWaveMentions={mentionedWaves} canMentionAll={t7} waveId={wave.id} isSaving={isSaving} onSave={t8} onCancel={t9} />;
      $[9] = isSaving;
      $[10] = mentionedGroups;
      $[11] = mentionedUsers;
      $[12] = mentionedWaves;
      $[13] = t6;
      $[14] = t7;
      $[15] = t8;
      $[16] = t9;
      $[17] = wave.id;
      $[18] = t10;
    } else {
      t10 = $[18];
    }
    return t10;
  }
  const t6 = drop?.nft_links;
  const t7 = drop?.id;
  const t8 = drop?.hide_link_preview;
  let t9;
  if ($[19] !== currentQuotePath || $[20] !== linkPreviewToggleControl || $[21] !== mentionedGroups || $[22] !== mentionedUsers || $[23] !== mentionedWaves || $[24] !== onLinkCardActionsActiveChange || $[25] !== onQuoteClick || $[26] !== part.content || $[27] !== referencedNfts || $[28] !== t6 || $[29] !== t7 || $[30] !== t8) {
    t9 = <DropPartMarkdownWithPropLogger mentionedUsers={mentionedUsers} mentionedGroups={mentionedGroups} mentionedWaves={mentionedWaves} referencedNfts={referencedNfts} nftLinks={t6} partContent={part.content} onQuoteClick={onQuoteClick} currentDropId={t7} hideLinkPreviews={t8} quotePath={currentQuotePath} linkPreviewToggleControl={linkPreviewToggleControl} onLinkCardActionsActiveChange={onLinkCardActionsActiveChange} />;
    $[19] = currentQuotePath;
    $[20] = linkPreviewToggleControl;
    $[21] = mentionedGroups;
    $[22] = mentionedUsers;
    $[23] = mentionedWaves;
    $[24] = onLinkCardActionsActiveChange;
    $[25] = onQuoteClick;
    $[26] = part.content;
    $[27] = referencedNfts;
    $[28] = t6;
    $[29] = t7;
    $[30] = t8;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] !== drop) {
    t10 = typeof drop?.updated_at === "number" && drop.updated_at !== drop.created_at && <div className="tw-mt-0.5 tw-text-[10px] tw-font-normal tw-leading-none tw-text-iron-500">(edited)</div>;
    $[32] = drop;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] !== t10 || $[35] !== t9) {
    t11 = <div>{t9}{t10}</div>;
    $[34] = t10;
    $[35] = t9;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] !== currentQuotePath || $[38] !== drop || $[39] !== onLinkCardActionsActiveChange || $[40] !== onQuoteClick || $[41] !== part.quoted_drop || $[42] !== wave) {
    t12 = part.quoted_drop?.drop_id && <div className="tw-mt-1.5"><WaveDropQuoteWithDropId dropId={part.quoted_drop.drop_id} partId={part.quoted_drop.drop_part_id} maybeDrop={part.quoted_drop.drop ? {
        ...part.quoted_drop.drop,
        wave
      } : null} onQuoteClick={onQuoteClick} embedPath={drop?.id ? [drop.id] : []} quotePath={currentQuotePath} embedDepth={1} onLinkCardActionsActiveChange={onLinkCardActionsActiveChange} /></div>;
    $[37] = currentQuotePath;
    $[38] = drop;
    $[39] = onLinkCardActionsActiveChange;
    $[40] = onQuoteClick;
    $[41] = part.quoted_drop;
    $[42] = wave;
    $[43] = t12;
  } else {
    t12 = $[43];
  }
  let t13;
  if ($[44] !== t11 || $[45] !== t12) {
    t13 = <>{t11}{t12}</>;
    $[44] = t11;
    $[45] = t12;
    $[46] = t13;
  } else {
    t13 = $[46];
  }
  return t13;
};
export default WaveDropPartContentMarkdown;